import { FormControl, FormErrorMessage, FormLabel, Input, VStack } from '@chakra-ui/react';

import DisplayInput from '~/components/DisplayInput';

type ConcatInfoSectionProps = {
  name: string;
  phone: string;
  phoneError: string;
  onChangePhone: (text: string) => void;
  isAuthMissingPhone: boolean;
};

export default function ConcatInfoSection({
  name,
  phone,
  isAuthMissingPhone,
  onChangePhone,
  phoneError,
}: ConcatInfoSectionProps) {
  return (
    <VStack align="stretch" spacing={4}>
      <FormControl isRequired>
        <FormLabel fontSize="sm" fontWeight="normal">
          姓名
        </FormLabel>
        <DisplayInput value={name} />
      </FormControl>

      <FormControl isRequired isInvalid={!!phoneError}>
        <FormLabel fontSize="sm" fontWeight="normal">
          手機
        </FormLabel>
        {!isAuthMissingPhone ? (
          <DisplayInput value={phone} />
        ) : (
          <>
            <Input
              value={phone}
              type="phone"
              inputMode="tel"
              onChange={(e: any) => onChangePhone(e.target.value)}
            />
            <FormErrorMessage>{phoneError}</FormErrorMessage>
          </>
        )}
      </FormControl>
    </VStack>
  );
}
